var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { stepClipStyle, stepClipWrapperStyle, sizeMap } from './styles';
function Steps(_a) {
    var id = _a.id, max = _a.max, size = _a.size;
    function renderStepRect(index) {
        var width = "".concat(100 / max, "%");
        return (_jsx("rect", { css: stepClipStyle({
                size: size,
                index: index,
                max: max,
            }), rx: parseInt(sizeMap[size].sizing) / 2, width: width }, index));
    }
    return (_jsx("svg", __assign({ css: stepClipWrapperStyle() }, { children: _jsx("defs", { children: _jsx("clipPath", __assign({ id: "".concat(id, "-clip") }, { children: Array.from({ length: max }, function (_, index) {
                    return renderStepRect(index);
                }) })) }) })));
}
export default Steps;
